import clsx from 'clsx';

export default function Field({
  label,
  htmlFor,
  required = false,
  description,
  error,
  children,
  className,
}) {
  const descriptionId = description ? `${htmlFor}-description` : undefined;
  const errorId = error ? `${htmlFor}-error` : undefined;

  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <label
        htmlFor={htmlFor}
        className="text-sm font-medium text-[rgba(var(--fg),_0.85)]"
      >
        {label}
        {required ? <span className="ml-1 text-[rgb(var(--brand))]">*</span> : null}
      </label>
      {description ? (
        <p id={descriptionId} className="text-xs text-[rgba(var(--fg),_0.65)]">
          {description}
        </p>
      ) : null}
      {children}
      {error ? (
        <p id={errorId} className="text-xs text-red-500 dark:text-red-300">
          {error}
        </p>
      ) : null}
    </div>
  );
}
